import React from 'react';
import { observer } from 'mobx-react-lite';
import { createMaterialCollapsibleTopTabNavigator } from 'react-native-collapsible-tab-view';
import { styled } from 'dripsy';
import { View } from 'react-native';
import { useTranslation } from 'react-i18next';
import { useRoute } from '@react-navigation/native';

import { screens } from './screens';
import { UserNewsScreen, UserTracksScreen } from '@screens';
import { UserProfileTabHeader } from './components/UserProfileTabHeader';
import { TopTabBar } from './components/TopTabBar';
import type {
  MusicNavigatorRoutePropType,
  PersonalizationNavigatorRoutePropType,
  UserProfileTabParamListType,
} from './types';
import { IS_MOBILE } from '@utils';

const TabNavigator =
  createMaterialCollapsibleTopTabNavigator<UserProfileTabParamListType>();

const TabBarContainer = styled(View)({
  px: ['$6', '$7', '5%'],
  bg: '$background0',
});

type RoutePropType =
  | MusicNavigatorRoutePropType<'UserProfileTabNavigator'>
  | PersonalizationNavigatorRoutePropType<'UserProfileTabNavigator'>;

export const UserProfileTabNavigator = observer(() => {
  const { t } = useTranslation();
  const route = useRoute<RoutePropType>();

  return (
    <TabNavigator.Navigator
      initialRouteName={screens.UserNews}
      tabBar={(props) => (
        <TabBarContainer>
          <TopTabBar {...props} />
        </TabBarContainer>
      )}
      collapsibleOptions={{
        renderHeader: () => <UserProfileTabHeader />,
        disableSnap: true,
        swipeEnabled: false,
        animationEnabled: IS_MOBILE,
      }}
    >
      <TabNavigator.Screen
        name={screens.UserNews}
        component={UserNewsScreen}
        initialParams={route.params}
        options={{
          title: t('userProfile.news'),
        }}
      />
      <TabNavigator.Screen
        name={screens.UserTracks}
        component={UserTracksScreen}
        initialParams={route.params}
        options={{
          title: t('userProfile.tracks'),
        }}
      />
    </TabNavigator.Navigator>
  );
});
